import { ResultId } from '@collector/sportsapi-client-legacy'
import { formatResultValue } from '@desktop/views/Relation/utils'

import { useParticipantResultsMaps } from './useParticipantResultsMaps'

type FormattedResultValue = string | number

/**
 * Display helpers for participant results — same formatting as the old
 * `getHomeParticipantResult` / `getAwayParticipantResult` (`null` / `''` → `-`),
 * backed by the cached `useParticipantResultsMaps` query select.
 */
export function useParticipantResult(): {
  getHomeParticipantResult: (resultId: ResultId | null) => FormattedResultValue
  getAwayParticipantResult: (resultId: ResultId | null) => FormattedResultValue
} {
  const { homeParticipantResultsMap, awayParticipantResultsMap } =
    useParticipantResultsMaps()

  function getHomeParticipantResult(
    resultId: ResultId | null,
  ): FormattedResultValue {
    const result =
      resultId === null ? undefined : homeParticipantResultsMap.value[resultId]

    return formatResultValue(result?.value ?? null)
  }

  function getAwayParticipantResult(
    resultId: ResultId | null,
  ): FormattedResultValue {
    const result =
      resultId === null ? undefined : awayParticipantResultsMap.value[resultId]

    return formatResultValue(result?.value ?? null)
  }

  return {
    getHomeParticipantResult,
    getAwayParticipantResult,
  }
}
